import React, { useCallback, useMemo } from 'react';
import { Container, Text } from '@pixi/react';
import CreateTextWinAmountAndCurrencySymbol from '../../createTextWinAmountAndCurrencySymbol';
import { applicationStore } from '../../../../../store/applicationStore';
import { exchangeAmount } from '../../../../../core/helpers/exchangeAmountByRate';

function BoostedJackpotInfoPopupPrizePool({
  lastWinnerDate,
  prizePoolAmount,
  lastWinnerAmount,
  largestWinnerDate,
  largestWinnerAmount,
  prizePoolLeftAmount,
}) {
  const {
    canvasTranslationKeys: { PRIZE_POOL, LAST_WINNER, LARGEST_WINNER, PRIZE_POOL_LEFT },
  } = applicationStore;

  const styles = useMemo(() => {
    return {
      fontSize: 11,
      fontWeight: 700,
      fontFamily: 'poppinsMedium',
      fill: '#FFFFFF',
      align: 'center',
    };
  }, []);

  const formattedDate = useCallback((value) => {
    if (!value) return '';

    const date = new Date(value);
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).format(date);
  }, []);

  const textOptions = useMemo(() => {
    return [
      {
        isHeader: true,
        option: {
          text: PRIZE_POOL,
          textX: 223,
          textY: 165,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        option: {
          text: exchangeAmount(prizePoolAmount),
          textX: 185,
          textY: 205,
          margin: 40,
          fontSize: 34,
        },
      },
      {
        isHeader: true,
        option: {
          text: PRIZE_POOL_LEFT,
          textX: 225,
          textY: 243,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        option: {
          text: exchangeAmount(prizePoolLeftAmount),
          textX: 205,
          textY: 270,
          margin: 20,
        },
      },
      {
        isHeader: true,
        option: {
          text: LAST_WINNER,
          textX: 100,
          textY: 303,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        isHeader: true,
        option: {
          text: formattedDate(lastWinnerDate),
          textX: 100,
          textY: 350,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        option: {
          text: exchangeAmount(lastWinnerAmount),
          textX: 85,
          textY: 330,
          margin: 20,
        },
      },
      {
        isHeader: true,
        option: {
          text: LARGEST_WINNER,
          textX: 350,
          textY: 303,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        isHeader: true,
        option: {
          text: formattedDate(largestWinnerDate),
          textX: 350,
          textY: 350,
          style: styles,
          anchor: 0.5,
          resolution: 2,
        },
      },
      {
        option: {
          text: exchangeAmount(largestWinnerAmount),
          textX: 327,
          textY: 330,
          margin: 20,
        },
      },
    ];
  }, [
    styles,
    PRIZE_POOL,
    LAST_WINNER,
    formattedDate,
    LARGEST_WINNER,
    PRIZE_POOL_LEFT,
    prizePoolAmount,
    lastWinnerAmount,
    prizePoolLeftAmount,
    largestWinnerAmount,
    largestWinnerDate,
    lastWinnerDate,
  ]);

  return (
    <Container name='BoostedJackpotInfoPopupPrizePool'>
      {textOptions.map(({ option, isHeader }) => {
        return (
          <>
            {isHeader ? (
              <Text {...option} x={option.textX} y={option.textY} />
            ) : (
              <CreateTextWinAmountAndCurrencySymbol
                x={option.textX}
                y={option.textY}
                amount={option.text}
                margin={option.margin}
                fontSize={option.fontSize}
              />
            )}
          </>
        );
      })}
    </Container>
  );
}

export default BoostedJackpotInfoPopupPrizePool;
